/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkbookItemType } from './WorkbookItemType';
import {
    WorkbookItemTypeFromJSON,
    WorkbookItemTypeFromJSONTyped,
    WorkbookItemTypeToJSON,
    WorkbookItemTypeToJSONTyped,
} from './WorkbookItemType';

/**
 * 
 * @export
 * @interface WorkbookItemDto
 */
export interface WorkbookItemDto {
    /**
     * 
     * @type {string}
     * @memberof WorkbookItemDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItemDto
     */
    title?: string | null;
    /**
     * 
     * @type {WorkbookItemType}
     * @memberof WorkbookItemDto
     */
    itemType?: WorkbookItemType;
    /**
     * 
     * @type {number}
     * @memberof WorkbookItemDto
     */
    sortOrder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbookItemDto
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItemDto
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItemDto
     */
    stateJson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItemDto
     */
    snapshotJson?: string | null;
}



/**
 * Check if a given object implements the WorkbookItemDto interface.
 */
export function instanceOfWorkbookItemDto(value: object): value is WorkbookItemDto {
    return true;
}

export function WorkbookItemDtoFromJSON(json: any): WorkbookItemDto {
    return WorkbookItemDtoFromJSONTyped(json, false);
}

export function WorkbookItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkbookItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'itemType': json['itemType'] == null ? undefined : WorkbookItemTypeFromJSON(json['itemType']),
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'isLocked': json['isLocked'] == null ? undefined : json['isLocked'],
        'version': json['version'] == null ? undefined : json['version'],
        'stateJson': json['stateJson'] == null ? undefined : json['stateJson'],
        'snapshotJson': json['snapshotJson'] == null ? undefined : json['snapshotJson'],
    };
}

export function WorkbookItemDtoToJSON(json: any): WorkbookItemDto {
    return WorkbookItemDtoToJSONTyped(json, false);
}

export function WorkbookItemDtoToJSONTyped(value?: WorkbookItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'itemType': WorkbookItemTypeToJSON(value['itemType']),
        'sortOrder': value['sortOrder'],
        'isLocked': value['isLocked'],
        'version': value['version'],
        'stateJson': value['stateJson'],
        'snapshotJson': value['snapshotJson'],
    };
}

